/**
 * This script dynamically updates image sources on a webpage based on the
 * website's domain and language. It's designed for a multi-regional
 * e-commerce site ("shopsta") to serve localized images.
 */
document.addEventListener("DOMContentLoaded", function() {
  // --- CURRENCY LOCALIZATION ---

  // Map of currency codes to their more native symbols.
  const currencyMap = {
    'DKK': 'kr.',
    'SEK': 'kr.',
    'PLN': 'zł',
    'CZK': 'Kč',
    'HUF': 'Ft',
    'RON': 'lei',
    'CHF': 'Fr.'
  };

  /**
   * Replaces a currency code with its symbol on a single DOM element.
   * This function is designed to be idempotent (safe to run multiple times).
   * @param {HTMLElement} el The element to process.
   */
  function processPriceElement(el) {
    let currentText = el.innerHTML;
    for (const [code, symbol] of Object.entries(currencyMap)) {
      // Only make a change if the currency code (e.g., "SEK") is found.
      if (currentText.includes(code)) {
        el.innerHTML = currentText.replace(code, symbol);
        // A price should only have one currency, so we can stop.
        break;
      }
    }
  }


  // --- IMAGE LOCALIZATION ---
  // Mapping of hostnames to language codes.
  const domainLangMap = {
    "www.shopsta.fr": "fr",
    "www.shopsta.nl": "nl",
    "www.shopsta.be": window.location.pathname.startsWith("/fr/") ? "fr" : "nl", // Handles dual-language .be domain
    "www.shopsta.de": "de",
    "www.shopsta.it": "it",
    "www.shopsta.es": "es",
    "www.shopsta.pl": "pl",
    "www.shopsta.pt": "pt",
    "www.shopsta.se": "sv",
    "www.shopsta.dk": "dk",
    "www.shopsta.hu": "hu",
    "www.shopsta.ro": "ro",
    "www.shopsta.cz": "cs",
    "www.shopsta.at": "de",
    "www.shopsta.ch": "de",
    "www.shopsta.lt": "lt",
    "www.shopsta.lv": "lv",
    "www.shopsta.ee": "et",
    "www.shopsta.gr": "el",
    "www.shopsta.ie": null, // No language specified
    "www.shopsta.co": null // Handled by special case below
  };

  // Determine the language from the current hostname.
  let lang = domainLangMap[window.location.hostname] || null;

  // Special case for Belgium (.be), which can be French or Dutch.
  if (window.location.hostname === "www.shopsta.be") {
    lang = window.location.pathname.startsWith("/fr/") ? "fr" : "nl";
  }

  // Special cases for the .co domain, which uses language subfolders.
  if (window.location.hostname === "www.shopsta.co") {
    if (window.location.pathname.startsWith("/hr/")) lang = "hr";
    if (window.location.pathname.startsWith("/de/")) lang = "de";
  }

  // If no language is determined for images, we can still run currency logic.
  // We only exit if language is needed for images.
  if (lang) {
    // Select all images within elements having the class "description-content".
    const imgs = document.querySelectorAll(".description-content img");

    imgs.forEach((img) => {
      const src = img.getAttribute("src");

      // Skip if the image has no src or already has the correct language identifier.
      if (!src || src.includes(`-lang-${lang}`)) return;

      // Construct the new image source URL with the language identifier.
      // e.g., "image.jpg" becomes "image-lang-fr.jpg"
      const extIndex = src.lastIndexOf(".");
      const newSrc =
        src.slice(0, extIndex) + `-lang-${lang}` + src.slice(extIndex);

      // Check if the new, language-specific image actually exists before swapping.
      fetch(newSrc, {
          method: "HEAD"
        })
        .then((res) => {
          // If the server confirms the image exists (res.ok is true), update the image src.
          if (res.ok) {
            img.src = newSrc;
          }
        })
        .catch(() => {
          // Catch any network errors and do nothing, keeping the original image.
        });
    });
  }


  // --- SCRIPT EXECUTION ---
  // 1. Run an initial check for any currency elements already on the page.
  document.querySelectorAll(".satcb_price.money").forEach(processPriceElement);

  // 2. Define the configuration for our observer.
  const observerConfig = {
    childList: true, // Watch for nodes being added or removed.
    subtree: true, // Watch descendants of the target node.
    characterData: true // Watch for changes to the text content of nodes.
  };

  // 3. Set up an observer to persistently enforce our currency format.
  const observer = new MutationObserver((mutationsList, obs) => {
    // First, disconnect the observer. This is critical to prevent an infinite
    // loop where our own changes below would trigger this observer again.
    obs.disconnect();

    // Find and fix all price elements on the page. This is more robust
    // than inspecting individual mutations and ensures we catch all reverts.
    document.querySelectorAll(".satcb_price.money").forEach(processPriceElement);

    // After we've made our changes, reconnect the observer to catch the
    // next time the plugin tries to revert our work.
    obs.observe(document.body, observerConfig);
  });

  // 4. Start observing the entire page for changes.
  observer.observe(document.body, observerConfig);
});

